//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { connect } from "react-redux";
// chrome-nav imports
import { ChromeNavGeneric } from "./ChromeNavGeneric";
import { IContainer, IProps, IState } from "./ChromeNavEventScheduler.d";
// other internals
import { SidebarDialog } from "@clockwise/web-commons/src/components/sidebar-dialog";
// util
import { track, TrackingEvents } from "@util/analytics.util";
// state
import {
  makeEventSchedulerViewActive,
  updateSchedulingSessionId,
} from "@actions/feed-scheduler.actions";
import { IReduxState } from "@reducers/root.reducer";
// material-ui
import { H2 } from "@ui";
import { Button, DialogActions, DialogContent } from "@material-ui/core";

//////////////////
// COMPONENT
//////////////////
class ChromeNavEventSchedulerCmpt extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      confirmationDialogOpen: false,
    };
  }

  // ~-~-~-~-~-~-~-
  // Helpers
  // ~-~-~-~-~-~-~-
  private onBack = () => {
    if (!this.props.eventSchedulerHasUnsavedChanges) {
      return this.goHome();
    }
    return this.openDialog(true);
  };

  private goHome = () => {
    track(TrackingEvents.SCHEDULING.EVENT_SCHEDULER_LEAVE, {
      schedulingSessionId: this.props.schedulingSessionId,
    }); // analytics
    this.props.updateSchedulingSessionId("");

    this.openDialog(false);
    this.props.makeEventSchedulerViewActive(false);
  };

  private openDialog = (confirmationDialogOpen: boolean) => {
    this.setState({ confirmationDialogOpen });
  };

  // ~-~-~-~-~-~-~-
  // Render
  // ~-~-~-~-~-~-~-
  private renderConfirmationDialog = () => {
    return (
      <SidebarDialog
        open={this.state.confirmationDialogOpen}
        onClose={() => this.openDialog(false)}
        isChromeExtension={this.props.isChromeExtension}
      >
        <DialogContent>
          <H2>Discard unsaved changes?</H2>
        </DialogContent>
        <DialogActions>
          <Button variant="text" onClick={this.goHome} color="primary">
            Discard
          </Button>
          <Button
            // keyboardFocused={true}
            variant="text"
            onClick={() => this.openDialog(false)}
          >
            Cancel
          </Button>
        </DialogActions>
      </SidebarDialog>
    );
  };

  public render() {
    return (
      <div>
        <ChromeNavGeneric
          label="New meeting"
          backDestination={this.props.defaultView}
          onBack={() => this.onBack()}
          settings
          feedback
        />
        {this.state.confirmationDialogOpen ? this.renderConfirmationDialog() : ""}
      </div>
    );
  }
}

//////////////////
// REDUX
//////////////////
function mapStateToProps(state: IReduxState, _ownProps: IContainer) {
  return {
    eventSchedulerHasUnsavedChanges: state.feedScheduler.eventSchedulerHasUnsavedChanges,
    schedulingSessionId: state.feedScheduler.schedulingSessionId,
    isChromeExtension: state.webExtension.isWebExtension,
  };
}

export const ChromeNavEventScheduler = connect(mapStateToProps, {
  makeEventSchedulerViewActive,
  updateSchedulingSessionId,
})(ChromeNavEventSchedulerCmpt);
